// Cached values - calculated once when container is first available
let cachedWidths: { dragHandle: number; actions: number; total: number } | null = null;

/**
 * Calculate ignored cell widths for highlight geometry
 */
export const getIgnoredCellWidths = (container: HTMLElement) => {
  if (cachedWidths) {
    return cachedWidths;
  }

  const firstRowLeftOffsetCell = container?.querySelector(
    'tr:first-child td.ignored-td-class:first-child'
  ) as HTMLTableCellElement | null;
  const firstRowRightOffsetCell = container?.querySelector(
    'tr:first-child td.ignored-td-class:last-child'
  ) as HTMLTableCellElement | null;

  const dragHandle = firstRowLeftOffsetCell?.offsetWidth ?? 0;
  const actions = firstRowRightOffsetCell?.offsetWidth ?? 0;

  cachedWidths = {
    dragHandle,
    actions,
    total: dragHandle + actions,
  };
  return cachedWidths;
};
